import React from 'react';
import PropTypes from 'prop-types';
import AdminHeader from '../../src/admin/layout/containers/AdminHeader';
import AdminNavbar from '../../src/admin/layout/components/AdminNavbar';
import AdminLayout from '../../src/admin/layout/components/AdminLayout';
import CurrentSiteNavigationSettings from '../containers/CurrentSiteNavigationSettings';
import Settings from '../components/Settings';

const propTypes = {
  params: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const NavigationEdit = ({
  params: {
    code,
  },
}) => {
  const header = (
    <AdminHeader title="Settings" />
  );

  const navbar = (
    <AdminNavbar />
  );

  return (
    <AdminLayout
      header={header}
      navbar={navbar}
    >
      <Settings>
        <CurrentSiteNavigationSettings code={code} />
      </Settings>
    </AdminLayout>
  );
};

NavigationEdit.propTypes = propTypes;
NavigationEdit.defaultProps = defaultProps;

export default NavigationEdit;
